/*
  Home page (English): section titles typed in capitals ("NEW ARRIVALS") read in sentence case,
  like every other title on the page. Only titles that are entirely capitals change; brand names
  keep their capitals. Other languages are left as typed (German nouns keep capitals).
*/
(function () {
  var lang = (document.documentElement.lang || "").toLowerCase();
  if (lang.indexOf("en") !== 0) return;
  var KEEP = { oceansouth: "Oceansouth", usa: "USA", us: "US", nz: "NZ", au: "AU", eu: "EU", atlas: "ATLAS" };
  function sentence(t) {
    var s = t.toLowerCase().replace(/[a-z]+/g, function (w) { return KEEP[w] || w; });
    return s.replace(/^(\s*)([a-z])/, function (m, sp, c) { return sp + c.toUpperCase(); });
  }
  function run() {
    document.querySelectorAll('[id^="shopify-section-template"] .content-heading').forEach(function (h) {
      var t = h.textContent;
      if (!/[A-Z]/.test(t) || t !== t.toUpperCase() || h.children.length) return;
      h.textContent = sentence(t);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
